// @ts-check
import React, { useEffect, useState } from "react"
import { clsx } from "../../../../../utils/strings.utils"

const TOGGLE_MS = 450

/**
 * Indicador de streaming: alterna entre contorno y relleno (sin color propio).
 */
export default function AssistantStreamingIndicator() {
  const [filled, setFilled] = useState(false)
  const [reduceMotion, setReduceMotion] = useState(false)

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)")
    setReduceMotion(mq.matches)
    const onChange = () => setReduceMotion(mq.matches)
    mq.addEventListener("change", onChange)
    return () => mq.removeEventListener("change", onChange)
  }, [])

  useEffect(() => {
    if (reduceMotion) return undefined
    const id = window.setInterval(() => {
      setFilled((v) => !v)
    }, TOGGLE_MS)
    return () => window.clearInterval(id)
  }, [reduceMotion])

  return (
    <span
      className="estimation-agent-quick-v3__stream-indicator"
      aria-hidden
    >
      <i
        className={clsx(
          reduceMotion ? "pi pi-circle" : filled ? "pi pi-circle-fill" : "pi pi-circle",
          "estimation-agent-quick-v3__stream-indicator-icon"
        )}
      />
    </span>
  )
}
